import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  languages: [],
  language: null
}

// mutations
export const mutations = {
  [types.SET_LANGUAGES] (state, languages) {
    state.languages = languages
  },
  [types.SET_LANGUAGE] (state, language) {
    state.language = language
  },
  [types.FETCH_LANGUAGE_FAILURE] (state) {
    state.language = null
  }
}

// actions
export const actions = {
  async fetchLanguages ({ commit }) {
    try {
      const { data } = await axios.get('/api/languages')
      commit(types.SET_LANGUAGES, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchLanguage ({ commit }, language) {
    try {
      const { data } = await axios.get(`/api/languages/${language.id}`)

      commit(types.SET_LANGUAGE, { language: data })
    } catch (e) {
      commit(types.FETCH_LANGUAGE_FAILURE)
    }
  },

  async createLanguage (context, language) {
    try {
      await axios.post('/api/languages', language)
      context.dispatch('fetchLanguages')
    } catch (e) {
      console.log(e)
    }
  },

  async updateLanguage (context, language) {
    try {
      await axios.put(`/api/languages/${language.id}`, language)
      context.dispatch('fetchLanguages')
    } catch (e) { }
  },

  async deleteLanguage (context, language) {
    try {
      await axios.delete(`/api/languages/${language.id}`)
      context.dispatch('fetchLanguages')
    } catch (e) { }
  }
}

// getters
export const getters = {
  languages: state => state.languages
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/language.js